import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { get } from 'lodash-es';
import { getCountVideoCommentSelector, getVideoIdSelector } from '../selectors';
import { getVideoAttachmentsTotalNumberSelector } from '../video-attachments/selector';
import { videoBoxSelector } from 'components/video-box/selectors';
import { videoAttachmentsFetchRequestAction } from 'components/video-box/video-attachments/actions';
import { getCustomerSelector, withCommentsFeatureSelector } from 'common/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { translateForCustomer } from 'utils/i18n';

const VideoBoxButton = ({ title, linkTo }) => (
  <Link to={linkTo}>
    <div className="ct-video-box__button">
      <div>{title}</div>
      <FontAwesomeIcon icon={faAngleRight} />
    </div>
  </Link>
);

const VideoBoxButtons = ({
  t,
  commentsTotal,
  attachmentsTotal,
  toComments,
  toAttachments,
  isVideoBoxLoading,
  withComments,
  fetchAttachments,
}) => {
  useEffect(() => {
    if (!isVideoBoxLoading) {
      fetchAttachments();
    }
  }, [isVideoBoxLoading, fetchAttachments]);
  const customer = useSelector(getCustomerSelector);

  return !isVideoBoxLoading ? (
    <React.Fragment>
      {withComments && (
        <div data-e2e="comments">
          <VideoBoxButton title={`${t('comments')} (${commentsTotal})`} linkTo={toComments} />
        </div>
      )}
      {attachmentsTotal > 0 ? (
        <div data-e2e="video-attachments-btn">
          <VideoBoxButton
            title={translateForCustomer('attachments.total', customer, { total: attachmentsTotal })}
            linkTo={toAttachments}
          />
        </div>
      ) : (
        <div data-e2e="video-attachments-btn-empty" />
      )}
    </React.Fragment>
  ) : null;
};

const mapStateToProps = (state, props) => {
  const videoId = getVideoIdSelector(state);
  const isVideoBoxLoading = get(videoBoxSelector(state), 'loading');

  return {
    withComments: withCommentsFeatureSelector(state),
    attachmentsTotal: getVideoAttachmentsTotalNumberSelector(state),
    commentsTotal: getCountVideoCommentSelector(state),
    toComments: `/comments/${videoId}`,
    toAttachments: `/attachments/${videoId}`,
    isVideoBoxLoading,
    videoId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAttachments: (videoId) => dispatch(videoAttachmentsFetchRequestAction(videoId)),
});

const mergeProps = (stateProps, dispatchProps, props) => {
  return {
    fetchAttachments: () => {
      dispatchProps.fetchAttachments(stateProps.videoId);
    },
    ...stateProps,
    ...props,
  };
};

export const VideoBoxButtonsDecorated = compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(VideoBoxButtons);
